export function initTestimonialsLogos() {
  document.querySelectorAll("[data-testimonials-logos]").forEach((block) => {
    const slides = Array.from(block.querySelectorAll("[data-testimonial-slide]"));
    const triggers = Array.from(block.querySelectorAll("[data-testimonial-trigger]"));
    const navigation = block.querySelector(".testimonials-logos-navigation");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!slides.length || !triggers.length) return;

    const duration = Number.parseInt(block.dataset.duration || "7000", 10);
    block.style.setProperty("--testimonial-duration", `${duration}ms`);
    block.style.setProperty("--testimonials-logos-count", triggers.length);
    let activeIndex = -1;
    let transitionCleanup;

    const restartProgress = (trigger) => {
      const fill = trigger.querySelector(".testimonials-logos-progress_fill");
      if (!fill || reduceMotion) return;
      fill.style.animation = "none";
      // Allow the reset to render before restarting; no forced layout read.
      requestAnimationFrame(() => requestAnimationFrame(() => {
        fill.style.animation = "";
      }));
    };

    const activate = (index, restart = true) => {
      if (!slides[index] || !triggers[index]) return;
      if (index === activeIndex && slides[index].classList.contains("is-active")) {
        if (restart) restartProgress(triggers[index]);
        return;
      }

      window.clearTimeout(transitionCleanup);
      const previousSlide = slides[activeIndex];
      const nextSlide = slides[index];

      slides.forEach((slide) => slide.classList.remove("is-leaving"));
      if (!reduceMotion && previousSlide && previousSlide !== nextSlide) {
        previousSlide.classList.add("is-leaving");
      }

      activeIndex = index;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-hidden", active ? "false" : "true");
      });
      triggers.forEach((trigger, triggerIndex) => {
        const active = triggerIndex === index;
        trigger.classList.toggle("is-active", active);
        trigger.setAttribute("aria-selected", active ? "true" : "false");
        trigger.tabIndex = active ? 0 : -1;
      });
      transitionCleanup = window.setTimeout(() => {
        slides.forEach((slide) => slide.classList.remove("is-leaving"));
      }, 550);
      if (restart) restartProgress(triggers[index]);
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener("click", () => {
        if (!navigation || navigation.scrollWidth <= navigation.clientWidth) {
          activate(index);
          return;
        }

        const navigationRect = navigation.getBoundingClientRect();
        const triggerRect = trigger.getBoundingClientRect();
        const left = navigation.scrollLeft + triggerRect.left + triggerRect.width / 2
          - navigationRect.left - navigation.clientLeft - navigation.clientWidth / 2;

        const scrollLeft = Math.max(0, Math.min(left, navigation.scrollWidth - navigation.clientWidth));
        activate(index);
        navigation.scrollTo({
          left: scrollLeft,
          behavior: reduceMotion ? "auto" : "smooth",
        });
      });
      //   trigger.addEventListener("pointerenter", () => activate(index));
      //   trigger.addEventListener("focus", () => activate(index));
      trigger.querySelector(".testimonials-logos-progress_fill")?.addEventListener("animationend", (event) => {
        if (event.animationName !== "testimonials-logos-progress" || index !== activeIndex) return;
        activate((index + 1) % slides.length);
      });
    });

    activate(0);
  });
}
